import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CartSet } from './shared-interface.types';

@Injectable({
  providedIn: 'root',
})
export class WebStorage {

  constructor(@Inject(PLATFORM_ID) private platformId: any) { }


  public StoredLead = new BehaviorSubject<any>(isPlatformBrowser(this.platformId) && localStorage.getItem('LeadEntityId') ? JSON.parse(localStorage.getItem('LeadEntityId')) : 0);
  public CustomerCoordinates = new BehaviorSubject<any>(isPlatformBrowser(this.platformId) && localStorage.getItem('CustomerCoordinates') ? JSON.parse(localStorage.getItem('CustomerCoordinates')) : 0);
  public CustomerGoogleAddress = new BehaviorSubject<any>(isPlatformBrowser(this.platformId) && localStorage.getItem('CustomerGoogleAddress') ? JSON.parse(localStorage.getItem('CustomerGoogleAddress')) : 0);
  public AvailablePackages = new BehaviorSubject<any>(isPlatformBrowser(this.platformId) && localStorage.getItem('AvailablePackages') ? JSON.parse(localStorage.getItem('AvailablePackages')) : 0);
  public CartInfo = new BehaviorSubject<any>(isPlatformBrowser(this.platformId) && localStorage.getItem('cartInfo') ? JSON.parse(localStorage.getItem('cartInfo')) : 0);
  public CustomerName = new BehaviorSubject<any>(0);
  public CustommerAmountOutstanding = new BehaviorSubject<any>(0);



  private cartProducts: Array<any> = [];
  private packageToCart: any;
  /**
   * Available Packages function
   * @param packages
   */
  public StorePackages(packagesValue: any): void {
    this.AvailablePackages.next(packagesValue);
    localStorage.setItem('AvailablePackages', JSON.stringify(packagesValue));
  }

  /**
   * Set LeadEntityID
   * @param leadEntityID
   */
  public SetLeadEntityID(leadEntityID: number): void {
    this.StoredLead.next(leadEntityID);
    localStorage.setItem('LeadEntityID', JSON.stringify(leadEntityID));
  }

  /**
   * Set Customer Coordinates
   * 
   */
  public SetCustomerCoordinates(cords: any) {
    localStorage.removeItem('CustomerCoordinates');
    this.CustomerCoordinates.next(cords)
    localStorage.setItem('CustomerCoordinates', JSON.stringify(cords));
  }

  /**
   * Set Customer Google Address
   * 
   */
  public SetCustomerGoogleAddress(place: any) {
    localStorage.removeItem('CustomerGoogleAddress');
    this.CustomerGoogleAddress.next(place)
    localStorage.setItem('CustomerGoogleAddress', JSON.stringify(place));
  }

  /**
  * Update Cart Badge function
  * @param value 
  * @param PackageEntityID 
  * @param LeadEntityID 
  */
  public async UpdateCart(value: CartSet, item?: any, LeadEntityID?: any): Promise<any> {
    const update: Record<CartSet, () => boolean> = {
      [CartSet.SET]: () => set(),
      [CartSet.DELETE]: () => remove(),
    };

    const set = (): boolean => {
      const packageToCart = {
        PackageEntityID: item?.PackageEntityID,
        LeadEntityID: LeadEntityID,
        Price: item.RecurringTotal ?? item.Billing_TotalTempIncl
      };

      this.CartInfo.next(packageToCart);
      localStorage.setItem('cartInfo', JSON.stringify(packageToCart));
      return true;
    }

    const remove = (): boolean => {
      this.CartInfo.next(0);
      localStorage.removeItem('cartInfo');
      return true;
    }

    return update[value]();
  }

  /**
   * Set Customer Name
   * 
   */
  public setCustomerName(name: string) {
    this.CustomerName.next(name)
  }

  /**
    * Set Customer Outstanding Amount
    * 
    */
  public setCustomerOustandingAnout(amount: number) {
    this.CustommerAmountOutstanding.next(amount)
  }

}